import axios from 'axios';

/**
 * Store API Client for public guest purchases
 * Uses session-based identification (no JWT auth)
 * withCredentials: true ensures session cookie persists across requests
 */
const isLocalHost = typeof window !== 'undefined'
  && /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);

const resolveApiBaseUrl = () => {
  if (import.meta.env.DEV || isLocalHost) {
    return '/api';
  }

  return import.meta.env.VITE_API_BASE_URL || 'https://api.pulseticket.es/api';
};

const tenantSlug = (typeof window !== 'undefined' && !isLocalHost)
  ? window.location.hostname
  : null;

const storeClient = axios.create({
  baseURL: resolveApiBaseUrl(),
  withCredentials: true, // Important for session persistence
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    ...(tenantSlug ? { 'X-Tenant-Slug': tenantSlug } : {}),
  },
});

storeClient.interceptors.request.use((config) => {
  const method = (config.method || 'get').toLowerCase();
  const url = config.url || '';

  if (method === 'get' && /^\/events(?:\/|$)/.test(url)) {
    config.params = {
      ...(config.params || {}),
      public_only: true,
    };
  }

  return config;
});

export default storeClient;
